import React, { createContext, useContext, useEffect } from 'react';
import { notification } from 'antd';
import { setErrorActions } from '../utils/utils';
import { LanguageContext } from './Language.context';

export const ErrorContext = createContext({});

export function ErrorContextProvider({ children }) {
  const {
    state: { literals },
    actions: { translate },
  } = useContext(LanguageContext);

  const actions = {
    showError: error => {
      let description = `${
        error?.response?.data?.message ||
        translate(`error.genericDesc`) ||
        'Por favor, inténtalo de nuevo más tarde'
      }`;
      notification.error({
        message: translate(`error.genericTitle`) || 'Algo ha ido mal',
        description,
      });
      console.log(error?.response?.data?.message);
    },
  };

  useEffect(() => {
    setErrorActions(actions);
  }, [, literals]);

  return <ErrorContext.Provider value={{ actions }}>{children}</ErrorContext.Provider>;
}
